import { EvalAnnotationStatusValues } from "../types";

export function isTerminalAnnotationStatus(status?: string | null): boolean {
  return (
    status === EvalAnnotationStatusValues.rejected ||
    status === EvalAnnotationStatusValues.exported
  );
}

export function canCreateAnnotation(status?: string | null): boolean {
  return !status;
}

export function canStartReview(status?: string | null): boolean {
  if (isTerminalAnnotationStatus(status)) {
    return false;
  }

  return status === EvalAnnotationStatusValues.pending;
}

export function canApproveOrReject(status?: string | null): boolean {
  return status === EvalAnnotationStatusValues.in_review;
}

export function canSanitise(
  status?: string | null,
  sanitised?: boolean,
): boolean {
  return (
    status === EvalAnnotationStatusValues.approved && sanitised !== true
  );
}

export function canExport(
  status?: string | null,
  sanitised?: boolean,
  exported?: boolean,
): boolean {
  return (
    status === EvalAnnotationStatusValues.approved &&
    sanitised === true &&
    exported !== true
  );
}

export function canShowGoldenRowPreview(
  status?: string | null,
  sanitised?: boolean,
): boolean {
  if (sanitised !== true) {
    return false;
  }

  return (
    status === EvalAnnotationStatusValues.approved ||
    status === EvalAnnotationStatusValues.exported
  );
}
